export default __webpack_public_path__ + "static/media/dobbi-logo-green.87aebe9a.png";